<app-svg-icon [icon]="icon" class="content-icon"></app-svg-icon>
